import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z
  .object({
    title: z.string().min(1, t('pages.application_news.components.news_edit_modal.schema.required')),
    content: z.string().min(1, t('pages.application_news.components.news_edit_modal.schema.required')),
    source_url: z.string().min(1, t('pages.application_news.components.news_edit_modal.schema.required')),
    is_published: z.boolean().optional(),
    is_scheduled: z.boolean().optional(),
    team_uuid: z.string().nullable().optional(),
    file: z
      .any()
      .refine(
        file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
        t('pages.application_news.components.news_edit_modal.schema.required_file'),
      ),
    publish_at: z
      .string()
      .optional()
      .transform(value => (value === '' ? undefined : value)),
  })
  .superRefine((values, ctx) => {
    if (values.is_scheduled && !values?.publish_at) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['publish_at'],
        message: t('pages.application_news.components.news_edit_modal.schema.required_publish_at'),
      });
    }
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
